import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TechnicalCompetence} from '../../shared/technical-competence';
import jQuery from 'jquery';

@Component({
    selector: 'occupational-profile-competence',
    templateUrl: './occupational-profile-competence.component.html',
    styleUrls: ['./occupational-profile-competence.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileCompetenceComponent implements OnInit {

    @Input()
    public competences?: Array<TechnicalCompetence>;
    @Input()
    public title!: string;
    @Input()
    public elementId!: string;

    showAllCompetences = false;
    restCompetences: Array<TechnicalCompetence> = new Array<TechnicalCompetence>();


    toggleAllCompetences(event: any): void {
        this.showAllCompetences = !this.showAllCompetences;
        (jQuery || $)(event.target).closest('.c-skills__show-extra').siblings('.extraCompetences').slideToggle(150);
    }

    ngOnInit(): void {
		if (this.competences) {
			this.restCompetences = this.competences.splice(5, this.competences.length);
		}
    }

    hasRestCompetences(): boolean {
        return this.restCompetences.length > 0;
    }
}
